import { Button, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

const ButtonIcon = ({ startIcon, children, sx, iconOnly = false, ...props }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const showLabel = isDesktop && !iconOnly;

    return (
        <Button
            startIcon={showLabel ? startIcon : undefined}
            sx={{
                ...sx,
                minWidth: showLabel ? (sx?.minWidth || 150) : 'auto',
                px: showLabel ? undefined : 1.5,
                '&.MuiButton-contained': {
                    py: showLabel ? '0.25em' : '6px',
                }
            }}
            {...props}
        >
            {showLabel ? children : startIcon}
        </Button>
    );
};

export default ButtonIcon;
